import { ReactNode } from 'react'
import { motion } from 'framer-motion'

interface HUDLayoutProps {
  title: string
  boatColor: string
  boatNumber: number
  children: ReactNode
  className?: string
}

export function HUDLayout({
  title,
  boatColor,
  boatNumber,
  children,
  className = '',
}: HUDLayoutProps) {
  return (
    <div
      className={`w-full h-screen flex flex-col bg-gradient-to-br from-palm-dark via-[#0f1419] to-palm-dark overflow-hidden ${className}`}
    >
      {/* Header */}
      <motion.div
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        className="relative p-6 border-b border-tropical-green border-opacity-30 backdrop-blur-sm"
      >
        <div className="flex items-center justify-between">
          <div>
            <h1 className="text-3xl font-fredoka font-700 text-sand-light">
              {title}
            </h1>
          </div>

          {/* Boat Color Indicator */}
          <motion.div
            animate={{ scale: [1, 1.05, 1] }}
            transition={{ duration: 2, repeat: Infinity }}
            className="flex items-center gap-3"
          >
            <div
              className="w-12 h-12 rounded-lg border-2 border-white transition-all duration-300"
              style={{
                backgroundColor: boatColor,
                boxShadow: `0 0 20px ${boatColor}80, inset 0 0 10px ${boatColor}40`,
              }}
            />
            <div>
              <div className="text-xs uppercase text-gray-400 font-quicksand">
                Boat
              </div>
              <div className="text-lg font-fredoka font-700 text-sand-light">
                #{boatNumber}
              </div>
            </div>
          </motion.div>
        </div>
      </motion.div>

      {/* Content */}
      <div className="flex-1 overflow-auto p-6">
        {children}
      </div>

      {/* Footer */}
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="p-4 border-t border-tropical-green border-opacity-30 backdrop-blur-sm text-center text-xs text-gray-400 font-quicksand"
      >
        Aqua-Rush - Live Display System
      </motion.div>
    </div>
  )
}
